import BaseForm from '../base';
export class EventsPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: [
        {
            type: 'select',
            label: 'Default Filter Events',
            key: 'defaultEvents',
            description: 'Define the list of events to be displayed in the events panel by default for all users.',
            multiple: true,
            data: {
                values: []
            },
            template: '<span class="pull-left">{{ item.label }}<br/><small>{{ item.value }}</small></span>',
            searchFields: ['label', 'value'],
            customOptions: {
                searchResultLimit: 10,
                classNames: {
                    button: 'choices__button pull-right'
                }
            },
        },
        {
            type: 'select',
            label: 'Available Filter Events',
            key: 'availableEvents',
            description: 'Define the list of events available to users to apply as custom filters within the filter modal.',
            multiple: true,
            data: {
                values: []
            },
            template: '<span class="pull-left">{{ item.label }}<br/><small>{{ item.value }}</small></span>',
            searchFields: ['label', 'value'],
            customOptions: {
                searchResultLimit: 10,
                classNames: {
                    button: 'choices__button pull-right'
                }
            },
        },
        {
            type: 'select',
            label: 'Available Acknowledgeable Events',
            key: 'acknowledgeableEvents',
            description: 'Filter to only show acknowledgeable options for the selected events.',
            multiple: true,
            data: {
                values: []
            },
            template: '<span class="pull-left">{{ item.label }}<br/><small>{{ item.value }}</small></span>',
            valueProperty: 'value',
            idPath: 'value',
            searchFields: ['label', 'value'],
            customOptions: {
                searchResultLimit: 10,
                classNames: {
                    button: 'choices__button pull-right'
                }
            },
        },
        {
            type: 'radio',
            label: 'How should events be sorted?',
            key: 'defaultOrderingMode',
            description: 'Choose whether to sort events based on when they happened or when they were last updated.',
            defaultValue: 'eventDate',
            values: [
                { label: 'Date and time event occurred', value: 'eventDate' },
                { label: 'Latest activity on the event', value: 'updatedAt' }
            ],
        },
        {
            type: 'number',
            label: 'Events older than this many hours will be sorted by when they occurred' +
                ' instead of their latest activity time',
            key: 'defaultOrderingFallbackHours',
            description: 'Leaving this empty keeps events sorted by their latest activity time,' +
                ' regardless of when they occurred.',
            suffix: 'hours',
            placeholder: 'Ex. 7',
            validate: {
                min: 0,
            },
            decimalLimit: 0,
            conditional: {
                show: true,
                when: 'defaultOrderingMode',
                eq: 'updatedAt',
            },
        },
        {
            type: 'checkbox',
            label: 'Play a sound when a new event arrives',
            key: 'newEventAlertsEnabled',
            description: 'When enabled, this panel will play a sound for each new event that is added to the list.',
            defaultValue: false,
        },
        {
            type: 'textfield',
            label: 'Sound URL Override',
            key: 'newEventAlertsSoundUrl',
            description: 'Optional default sound URL override. Full URL to an MP3 or WAV file ' +
                'to play for new events (for example, a file hosted in S3).',
            placeholder: 'https://your-bucket.s3.amazonaws.com/alerts/new-event.mp3',
            conditional: {
                show: true,
                when: 'newEventAlertsEnabled',
                eq: 'true',
            },
        },
    ]
};
